module.exports = require("././angular-resource.js");


//////////////////
// WEBPACK FOOTER
// angular-resource (bower component)
// module id = 1455
// module chunks = 1